import React from "react";
import Navbar from "../components/Navbar";
import FinalizeRecoveryForm from "../components/FinalizeRecoveryForm";
import { WalletInfo } from "../contexts/WalletContext";

import "./FinalizeTxPage.css";

function FinalizeTxPage() {
  const recoveryHash = "0xabcd...1234";

  return (
    <div className="finalize-tx-page">
      <Navbar activePage="finalize-tx" />
      <FinalizeRecoveryForm recoveryHash={recoveryHash} />
    </div>
  );
}

export default FinalizeTxPage;
